import engine from "app/core/liquid/engine"
import { z } from "zod"

export const LiquidString = z.string().superRefine((val, ctx) => {
  try {
    engine.parse(val)
  } catch {
    ctx.addIssue({
      validation: "regex",
      code: z.ZodIssueCode.invalid_string,
      message: "Invalid Liquid template",
    })
  }
})
